import React, { useState } from "react";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  deleteAllUnavailable,
  getUnavialable,
  getUnavialableAppointment,
} from "../../redux/action/Appointment";
import { CalendarX, ChevronLeft, ChevronRight, Info } from "lucide-react";
import moment from "moment";
import NoRecent from "../../Component/NoAppointment";
import EditPopup from "../Unavailable";
import DeletePopup from "../Unavailable/DeleteUnavailable";
import EditUnPopUp from "../Unavailable/EditUnavalable";
import Model from "../Model";

import {
  resetDeleteUnavailable,
  resetDeleteUnavailableSlot,
  resetEditUnavailable,
} from "../../redux/slice/Appointment";
import IMAGES from "../../constants/images";

import DeleteModel from "../DeleteModel";

export default function UnavailableCalender() {
  const dispatch = useDispatch();
  const { deleteAllUnData, deleteAllUnLoading, deleteAllUnError } = useSelector(
    (state) => state.DELETE_ALL_UNAVAILABLE
  );
  const [title, setTitle] = useState(null);
  const [description, setDescription] = useState(null);
  const [icon, setIcon] = useState(null);
  const [show, setShow] = useState(false);
  const [deleteAllConfirmation, setDeleteAllConfirmation] = useState(false);

  const { range, rangeError, rangeLoading } = useSelector(
    (state) => state.GET_UNAVIALABLE
  );
  const { data, error, loading } = useSelector(
    (state) => state.GET_UNAVIALABLE_APPOINTMENT
  );
  const { editData, errorEdit } = useSelector(
    (state) => state.UPDATE_UNAVAILABLE
  );
  const { deleteData, errorDelete } = useSelector(
    (state) => state.DELETE_UNAVAILABLE
  );
  const today = new Date();

  const [currentMonth, setCurrentMonth] = useState(today.getMonth());
  const [currentYear, setCurrentYear] = useState(today.getFullYear());
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedUnavailable, setSelectedUnavailable] = useState(null);
  const [selectedDuration, setSelectedDuration] = useState(null);
  const [unavailableData, setUnavailableData] = useState([]);
  const [open, setopen] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [slotID, setSlotID] = useState(null);
  const [editpop, setEditpop] = useState(false);
  const [reason, setReason] = useState(null);
  const isInRange = (year, month, day) => {
    if (!startDate || !endDate) return false;
    const date = new Date(year, month, day);
    return date >= startDate && date <= endDate;
  };

  const isRangeStart = (year, month, day) => {
    if (!startDate) return false;
    const date = new Date(year, month, day);
    return date.getTime() === startDate.getTime();
  };

  const isRangeEnd = (year, month, day) => {
    if (!endDate) return false;
    const date = new Date(year, month, day);
    return date.getTime() === endDate.getTime();
  };

  useEffect(() => {
    dispatch(getUnavialable());
  }, []);

  useEffect(() => {
    if (deleteAllUnData) {
      setShow(true);
      dispatch(getUnavialable());
      setTitle("Unvailability Deleted");
      setDescription("");
      setIcon(IMAGES.slot_success);
    }
    if (deleteAllUnError) {
      setShow(true);

      setTitle("Unvailability Deletition Failed");
      setDescription("Your  unavailability deletetion failed.");
      setIcon(IMAGES.slot_error);
    }
  }, [deleteAllUnData, deleteAllUnError]);

  const isToday = (year, month, day) => {
    return (
      day === today.getDate() &&
      month === today.getMonth() &&
      year === today.getFullYear()
    );
  };
  const formatDate = (date) => {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return `${monthNames[date.getMonth()]} ${date.getDate()}`;
  };
  const getMonthName = (month) => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return monthNames[month];
  };

  const prevMonth = () => {
    if (currentMonth === 0) {
      setCurrentMonth(11);
      setCurrentYear(currentYear - 1);
    } else {
      setCurrentMonth(currentMonth - 1);
    }
  };

  const nextMonth = () => {
    if (currentMonth === 11) {
      setCurrentMonth(0);
      setCurrentYear(currentYear + 1);
    } else {
      setCurrentMonth(currentMonth + 1);
    }
  };

  const isDateUnavailable = (year, month, day) => {
    const currentDate = new Date(year, month, day);
    if (!range?.unAvailableSchedules) return false;

    return range.unAvailableSchedules.some((entry) => {
      const start = new Date(entry.unaAvailableStartDate);
      const end = new Date(entry.unaAvailableEndDate);
      return currentDate >= start && currentDate <= end;
    });
  };

  const getUnavailableRange = (year, month, day) => {
    const currentDate = new Date(year, month, day);
    if (!range?.unAvailableSchedules) return null;

    return range.unAvailableSchedules.find((entry) => {
      const start = new Date(entry.unaAvailableStartDate);
      const end = new Date(entry.unaAvailableEndDate);
      return currentDate >= start && currentDate <= end;
    });
  };

  const renderCalendar = () => {
    const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
    const unavailableRanges = Array.isArray(range?.unAvailableSchedules)
      ? range.unAvailableSchedules
      : [];

    const firstDayOfMonth = new Date(currentYear, currentMonth, 1).getDay();
    const daysOfWeek = ["S", "M", "T", "W", "T", "F", "S"];
    const blanks = Array(firstDayOfMonth).fill(null);
    const days = Array.from({ length: daysInMonth }, (_, i) => i + 1);
    const calendarDays = [...blanks, ...days];
    const weeks = [];
    let week = [];

    calendarDays.forEach((day, i) => {
      week.push(day);
      if ((i + 1) % 7 === 0 || i === calendarDays.length - 1) {
        weeks.push(week);
        week = [];
      }
    });

    return (
      <div className="mt-0">
        <div className="grid grid-cols-7 text-center mb-1.5 bg-[#FFF7ED] rounded-lg">
          {daysOfWeek.map((day, index) => (
            <div
              key={index}
              className={`font-semibold font-poppins text-[11px] py-1.5 ${
                index === 0 || index === 6 ? "text-[#E11D48]" : "text-[#EA580C]"
              }`}
            >
              {day}
            </div>
          ))}
        </div>

        {weeks.map((week, weekIndex) => (
          <div key={weekIndex} className="grid grid-cols-7 text-center">
            {week.map((day, dayIndex) => {
              if (day === null) {
                return (
                  <div key={dayIndex} className="h-7 md:h-8 p-1 relative" />
                );
              }

              const date = new Date(currentYear, currentMonth, day);

              // Check if this date matches the start or end of any range
              const isRangeStartDate = unavailableRanges.some(
                ({ unaAvailableStartDate }) => {
                  return (
                    moment(date).format("YYYY-MM-DD") === unaAvailableStartDate
                  );
                }
              );

              const isRangeEndDate = unavailableRanges.some(
                ({ unaAvailableEndDate }) =>
                  date.toDateString() ===
                  new Date(unaAvailableEndDate).toDateString()
              );

              // Check if this date is in any unavailable range
              const isUnavailable = unavailableRanges.some(
                ({ unaAvailableStartDate, unaAvailableEndDate }) => {
                  const start = new Date(unaAvailableStartDate);
                  const end = new Date(unaAvailableEndDate);
                  start.setHours(0, 0, 0, 0);
                  end.setHours(0, 0, 0, 0);
                  const current = new Date(date);
                  current.setHours(0, 0, 0, 0);
                  return current >= start && current <= end;
                }
              );

              const isTodayDate = isToday(currentYear, currentMonth, day);
              const isPastDate =
                date <
                new Date(today.getFullYear(), today.getMonth(), today.getDate());

              let tileColor = "bg-white text-[#171717] shadow-sm";
              if (isPastDate) tileColor = "bg-transparent text-[#CBD5E1]";
              if (isUnavailable)
                tileColor = "bg-transparent text-[#B91C1C] font-semibold";
              if (isUnavailable && (isRangeStartDate || isRangeEndDate))
                tileColor = "bg-[#DC2626] text-white font-semibold shadow-md";
              if (isTodayDate && !isUnavailable)
                tileColor = "bg-[#0F172A] text-white font-semibold shadow-md";

              let outerClasses =
                "h-10 md:h-12 flex justify-center items-center relative cursor-pointer ";
              if (isUnavailable) {
                outerClasses += "bg-[#FCD9D9] ";
                if (isRangeStartDate) outerClasses += "rounded-l-[50px] ";
                if (isRangeEndDate) outerClasses += "rounded-r-[50px] ";
              }
              {
                /* const isRangeEndDate = isRangeEnd(currentYear, currentMonth, day);
              const isTodayDate = isToday(currentYear, currentMonth, day);
              const isUnavailable = isDateUnavailable(
                currentYear,
                currentMonth,
                day
              ); */
              }

              return (
                <div
                  key={dayIndex}
                  className={`h-7 md:h-8 relative px-0.5 flex items-center justify-center cursor-pointer ${
                    isUnavailable ? "bg-[#FEE2E2]" : ""
                  } ${
                    isRangeStartDate ? "!rounded-l-[50px] bg-[#FEE2E2]" : ""
                  } ${isRangeEndDate ? "rounded-r-[50px]" : ""}`}
                  onClick={() => {
                    if (isUnavailable) {
                      setopen(true);
                      const data = unavailableRanges.find(
                        ({ unaAvailableStartDate, unaAvailableEndDate }) => {
                          const start = new Date(unaAvailableStartDate);
                          const end = new Date(unaAvailableEndDate);
                          const current = new Date(date);
                          start.setHours(0, 0, 0, 0);
                          end.setHours(0, 0, 0, 0);
                          current.setHours(0, 0, 0, 0);
                          return current >= start && current <= end;
                        }
                      );
                      if (data) {
                        setReason(data.reason);
                        // filterData(data.scheduleId);
                        setSlotID(data.scheduleId);
                        setSelectedDuration(
                          data.unaAvailableStartDate +
                            " to " +
                            data.unaAvailableEndDate
                        );
                      }
                    }
                  }}
                >
                  <div
                    className={`flex items-center  justify-center h-7 w-7 rounded-lg text-xs font-poppins z-10
                            ${tileColor}
                          `}
                  >
                    {day}
                  </div>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    );
  };

  const getUnavialableData = () => {
    dispatch(getUnavialableAppointment());
  };
  useEffect(() => {
    getUnavialableData();
  }, []);

  // const filterData = (id) => {
  //   if (data[id]) {
  //     setUnavailableData([...data[id]]);
  //   } else {
  //     setUnavailableData([]);
  //   }
  // };

  useEffect(() => {
    if (editData) {
      dispatch(getUnavialable());
      if (editData === "Schedule Updated") {
        setShow(true);

        setTitle("Unvailability Updated");
        setDescription("Your unavailability updated successfully.");
        setIcon(IMAGES.slot_success);
      }
    }
    if (errorEdit) {
      setShow(true);

      setTitle("Availability Updation Failed");
      setDescription(errorEdit?.payload);
      setIcon(IMAGES.slot_error);
    }
  }, [editData, errorEdit]);

  useEffect(() => {
    if (deleteData) {
      dispatch(getUnavialable());
      if (deleteData === "Schedule deleted successfully.") {
        setShow(true);

        setTitle("Unvailability Deleted");
        setDescription("Schedule deleted successfully.");
        setIcon(IMAGES.slot_success);
      }
    }
    if (errorDelete) {
      setShow(true);

      setTitle("Availability Deletion Failed");
      setDescription(errorDelete?.payload);
      setIcon(IMAGES.slot_error);
    }
  }, [deleteData, errorDelete]);

  const deleteAllUnavailableConfirmation = () => {
    setTitle("Delete all unavailability");
    setDeleteAllConfirmation(true);
  };

  return (
    <div className="w-full px-0 sm:w-full ">
      <div className="w-full sm:w-full h-auto bg-white border-[1px] border-solid border-[#E2E8F0] shadow-sm rounded-2xl mt-1 p-[16px]">
        <div className="flex items-center gap-2.5 pb-2.5 mb-3 border-b-[1px] border-solid border-x-0 border-t-0 border-[#F1F5F9]">
          <div className="flex items-center justify-center w-[32px] h-[32px] rounded-lg bg-[#FFF7ED] text-[#EA580C] flex-shrink-0">
            <CalendarX size={16} />
          </div>
          <h1 className="text-base font-semibold text-[#171717] font-poppins mb-0">
            Your Unavailability & Reschedules
          </h1>
          {/* <Info className="ml-2 text-gray-500 h-5 w-5" /> */}
          <p
            className="ml-auto flex-shrink-0 text-[11px] font-poppins text-[#DC2626] bg-[#FEF2F2] hover:bg-[#FEE2E2] px-2.5 py-1 rounded-full font-semibold cursor-pointer mb-0 transition-colors"
            onClick={() => deleteAllUnavailableConfirmation()}
          >
            Clear All
          </p>
        </div>
        <div className="w-full max-w-[360px] mx-auto p-[12px] bg-[#F8FAFC] border-[1px] border-solid border-[#F1F5F9] rounded-2xl">
          <div className="flex w-[100%] items-center justify-between mb-0 px-1">
            <button
              type="button"
              onClick={prevMonth}
              className="flex items-center justify-center w-8 h-8 p-0 rounded-lg bg-white shadow-sm hover:bg-[#F8FAFC] transition-colors"
              aria-label="Previous month"
              style={{ border: "1px solid #E2E8F0" }}
            >
              <ChevronLeft size={18} className="text-[#334155]" />
            </button>

            <div className="flex items-center">
              <span className="text-[#171717] font-poppins font-semibold text-[14px]">
                {getMonthName(currentMonth)} {currentYear}
              </span>
            </div>

            <button
              type="button"
              onClick={nextMonth}
              className="flex items-center justify-center w-8 h-8 p-0 rounded-lg bg-white shadow-sm hover:bg-[#F8FAFC] transition-colors"
              aria-label="Next month"
              style={{ border: "1px solid #E2E8F0" }}
            >
              <ChevronRight size={18} className="text-[#334155]" />
            </button>
          </div>
          <div className="w-full mt-2">{renderCalendar()}</div>

          <div className="flex flex-wrap items-center gap-x-4 gap-y-1.5 mt-3 px-1 text-[11px] font-poppins text-[#64748B]">
            <span className="flex items-center gap-1.5">
              <span className="w-2.5 h-2.5 rounded-[4px] bg-[#0F172A]"></span>Today
            </span>
            <span className="flex items-center gap-1.5">
              <span className="w-2.5 h-2.5 rounded-[4px] bg-[#DC2626]"></span>Unavailable
            </span>
            <span className="flex items-center gap-1.5">
              <span className="w-2.5 h-2.5 rounded-[4px] bg-white border-[1px] border-solid border-[#E2E8F0]"></span>Available
            </span>
          </div>
        </div>

        <div className="flex justify-between items-center mt-4 pt-4 border-t-[1px] border-solid border-x-0 border-b-0 border-[#F1F5F9]">
          <span className="text-[#64748B] text-[11px] uppercase tracking-wide font-semibold font-poppins">
            Unavailable Dates
          </span>
          {selectedDuration !== null ? (
            <div className="py-1 px-2.5 bg-[#F1F5F9] rounded-full font-poppins font-medium text-[#334155] text-xs">
              {selectedDuration}
            </div>
          ) : null}
        </div>
        <div className="mt-3">
          {Object.values(data).flat().length > 0 ? (
            <>
              <table className="w-full text-xs whitespace-nowrap">
                <thead>
                  <tr className="bg-[#F8FAFC] text-[#64748B] text-[11px] tracking-wide font-semibold font-poppins text-left">
                    <th className="px-3 py-2 uppercase rounded-l-xl">Date</th>
                    <th className="px-3 py-2 uppercase">Time Slot</th>
                    <th className="px-3 py-2 uppercase">Patient Name</th>
                    <th className="px-3 py-2 uppercase rounded-r-xl">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.values(data)
                    .flat()
                    .map((item, index) => {
                      return (
                        <tr
                          key={index}
                          className="border-b-[1px] border-solid border-x-0 border-t-0 border-[#F1F5F9] last:border-b-0 text-[#334155] hover:bg-[#F8FAFC] transition"
                        >
                          <td className="px-3 py-2 text-xs font-poppins">
                            {moment(item.appointmentStartDate).format(
                              "DD MMM YYYY"
                            )}
                          </td>
                          <td className="px-3 py-2 text-xs font-poppins">
                            {moment(item.appointmentStartDate).format("hh:mm")}-{" "}
                            {moment(item.appointmentEndDate).format("hh:mm")}
                          </td>
                          <td className="px-3 py-2 text-xs font-poppins">
                            {item.clientNameString}
                          </td>
                          <td className="px-3 py-2 text-xs font-poppins">
                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full bg-[#FEF2F2] text-[#DC2626] text-[11px] font-semibold">
                              <span className="w-1.5 h-1.5 bg-[#DC2626] rounded-full"></span>
                              <span className="ml-1.5">
                                Practitioner Unavailable
                              </span>
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </>
          ) : (
            <NoRecent />
          )}
        </div>
      </div>
      {open && (
        <EditPopup
          isOpen={open}
          onClose={setopen}
          time={selectedDuration}
          editDialog={deleteDialog}
          editpop={setEditpop}
          setEditDialog={(v) => {
            setDeleteDialog(v);
            setopen(false);
          }}
        />
      )}
      {deleteDialog && (
        <DeletePopup
          isOpen={deleteDialog}
          onClose={setDeleteDialog}
          time={selectedDuration}
          editDialog={deleteDialog}
          setEditDialog={setDeleteDialog}
          slotID={slotID}
        />
      )}
      {editpop && (
        <EditUnPopUp
          isOpen={editpop}
          slotID={slotID}
          reason={reason}
          onClose={setEditpop}
          time={selectedDuration}
          editDialog={deleteDialog}
          setEditDialog={setDeleteDialog}
        />
      )}

      {show && (
        <Model
          show={show}
          setShow={(v) => {
            setShow(v);
            dispatch(resetEditUnavailable());
            dispatch(resetDeleteUnavailable());
            dispatch(resetDeleteUnavailableSlot());
          }}
          title={title}
          description={description}
          icon={icon}
        />
      )}
      {deleteAllConfirmation && (
        <DeleteModel
          show={deleteAllConfirmation}
          setShow={(v) => {
            setDeleteAllConfirmation(false);
          }}
          title={title}
          description={"are you sure you want to delete all unavailability"}
          icon={IMAGES.delete_unavailable}
          onDelete={() => {
            //dispatch(deleteAllSchedule());
            dispatch(deleteAllUnavailable());
          }}
        />
      )}
    </div>
  );
}
